import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { APP_SETTINGS } from '../../app-settings';
import { Observable } from 'rxjs';

@Injectable()
export class GeneralApiService {
    private apiEndpoint;

    constructor(
        private http: HttpClient,
        @Inject(APP_SETTINGS) private appSettings
    ) {
        this.apiEndpoint = appSettings.apiEndpoint;
    }

    public parseErrorBlob(err: HttpErrorResponse): Observable<any> {
        const reader = new FileReader();
        return new Observable((observer) => {
            reader.onloadend = () => {
                try {
                    observer.error(JSON.parse(reader.result as string));
                } catch (e) {
                    observer.error(e);
                }
                observer.complete();
            };
            reader.onerror = (error) => {
                observer.error(error);
            };
            reader.readAsText(err.error);
        });
    }
}
